<script setup>
import {ref} from "vue";
import {useLanguageStore} from "@/pinia";

const props = defineProps(['isNameChangeModal', 'subModalType', 'subModalValue'])
const emits = defineEmits(['set_isNameChangeModal', 'editName'])
const name = ref();
const languageStore = useLanguageStore();
const save = ()=>{
  emits('editName', name.value);
  name.value ="";
  close();
}
const close = ()=>{
  name.value ="";
  emits('set_isNameChangeModal', false)
}
</script>

<template>
  <v-dialog
      :model-value="isNameChangeModal"
      @update:modelValue="close"
      width="auto"
  >
    <v-card
        :title="languageStore.get('renameAction')"
        width="600"
    >
      <v-card-text>
        <v-text-field
            v-model="name"
            :label="languageStore.get('newName') + ' *'"
            variant="outlined"
            density="compact"
            hide-details="auto"
            autofocus
            @keyup.enter="save"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="modal-actions">
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" @click="save">{{ languageStore.get('save') }}</v-btn>
        <v-btn variant="outlined" @click="close">{{ languageStore.get('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
/* 모달 헤더 스타일 */
:deep(.v-card-title) {
  background-color: #1A3A5C !important;
  color: #FFFFFF !important;
  padding: 16px 24px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

/* 모달 바디 - Vuetify 기본 padding 제거 */
:deep(.v-card-text) {
  padding: 24px !important;
}

/* 모달 액션 - Vuetify 기본 padding 제거 */
:deep(.v-card-actions.modal-actions) {
  padding: 16px 24px !important;
  border-top: 1px solid #DEE2E6;
  gap: 8px;
}

/* v-card-text 내 입력 필드 간격 */
.v-card-text :deep(.v-input) {
  margin-bottom: 16px;
}

.v-card-text :deep(.v-input:last-child) {
  margin-bottom: 0;
}
</style>